import { render } from "./your-profile-scheme-details-component.vue?vue&type=template&id=29766f69"
import script from "./your-profile-scheme-details-component.vue?vue&type=script&lang=js"
export * from "./your-profile-scheme-details-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__